<template>
    <footer class="footer">Copyright © 2018-2019 Yi Group</footer>
</template>
<script>
export default {
    
}
</script>
<style>
    .footer{color: white;padding: 70px 0 65px 0;text-align: center;}
</style>


